import { useState } from "react";
import ExpenseForm from "./ExpenseForm";
import IncomeForm from "./IncomeForm";
import TransferForm from "./TransferForm";
import TransactionList from "./TransactionList";
import BudgetDashboard from "./BudgetDashboard";
import TrendDashboard from "./TrendDashboard";
import SplitTransactionForm from "./SplitTransactionForm";
import "./Transactions.css";
import { formatTransactionTypeLabel, normalizeTransactionType } from "./transactionUtils";

const TABS = ["EXPENSE", "INCOME", "TRANSFER", "TRANSACTION_LIST", "BUDGETS", "TRENDS", "SPLIT"];

export default function Transactions(){

  const [tab,setTab] = useState("EXPENSE");
  const [refreshSignal, setRefreshSignal] = useState(0);
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [splitTransaction, setSplitTransaction] = useState(null);

  const handleSaved = () => {
    setRefreshSignal((current) => current + 1);
    setEditingTransaction(null);
    setSplitTransaction(null);
    setTab("TRANSACTION_LIST");
  };

  const startEdit = (transaction) => {
    setEditingTransaction(transaction);
    setSplitTransaction(null);
    setTab(normalizeTransactionType(transaction.transactionType));
  };

  const startSplit = (transaction) => {
    setSplitTransaction(transaction);
    setEditingTransaction(null);
    setTab("SPLIT");
  };

  const cancelMode = () => {
    setEditingTransaction(null);
    setSplitTransaction(null);
    setTab("TRANSACTION_LIST");
  };

  return (
    <div className="card">
      <div className="card-title">Transaction Workspace</div>
    
      {/* Tabs */}
      <div className="transactions-tabs">
        {TABS.map(t=>(
          <button
            key={t}
            className={`tab-btn ${tab===t ? "active":""}`}
            onClick={()=>{
              if (t !== "SPLIT") {
                setSplitTransaction(null);
              }
              if (!["EXPENSE", "INCOME", "TRANSFER"].includes(t)) {
                setEditingTransaction(null);
              }
              setTab(t);
            }}
          >
            {t.replace("_"," ")}
          </button>
        ))}
      </div>

      {editingTransaction && ["EXPENSE", "INCOME", "TRANSFER"].includes(tab) && (
        <div className="transactions-mode-banner">
          Editing {formatTransactionTypeLabel(editingTransaction.transactionType)} from {editingTransaction.transactionDate}
        </div>
      )}

      {splitTransaction && tab === "SPLIT" && (
        <div className="transactions-mode-banner">
          Splitting {formatTransactionTypeLabel(splitTransaction.transactionType)} worth {splitTransaction.transactionAmount}
        </div>
      )}

      {/* Forms */}
      {tab === "EXPENSE" && (
        <ExpenseForm
          initialValues={normalizeTransactionType(editingTransaction?.transactionType) === "EXPENSE" ? editingTransaction : null}
          title={editingTransaction ? "Edit Expense" : "Add Expense"}
          submitLabel={editingTransaction ? "Save Changes" : "Save Expense"}
          replaceTransactionId={normalizeTransactionType(editingTransaction?.transactionType) === "EXPENSE" ? editingTransaction?.id : undefined}
          onSaved={handleSaved}
          onCancel={editingTransaction ? cancelMode : undefined}
        />
      )}
      {tab === "INCOME" && (
        <IncomeForm
          initialValues={normalizeTransactionType(editingTransaction?.transactionType) === "INCOME" ? editingTransaction : null}
          title={editingTransaction ? "Edit Income" : "Add Income"}
          submitLabel={editingTransaction ? "Save Changes" : "Save Income"}
          replaceTransactionId={normalizeTransactionType(editingTransaction?.transactionType) === "INCOME" ? editingTransaction?.id : undefined}
          onSaved={handleSaved}
          onCancel={editingTransaction ? cancelMode : undefined}
        />
      )}
      {tab === "TRANSFER" && (
        <TransferForm
          initialValues={normalizeTransactionType(editingTransaction?.transactionType) === "TRANSFER" ? editingTransaction : null}
          title={editingTransaction ? "Edit Transfer" : "Transfer"}
          submitLabel={editingTransaction ? "Save Changes" : "Transfer"}
          replaceTransactionId={normalizeTransactionType(editingTransaction?.transactionType) === "TRANSFER" ? editingTransaction?.id : undefined}
          onSaved={handleSaved}
          onCancel={editingTransaction ? cancelMode : undefined}
        />
      )}
      {tab === "TRANSACTION_LIST" && (
        <TransactionList
          refreshSignal={refreshSignal}
          onEditTransaction={startEdit}
          onSplitTransaction={startSplit}
        />
      )}
      {tab === "BUDGETS" && <BudgetDashboard refreshSignal={refreshSignal} />}
      {tab === "TRENDS" && <TrendDashboard refreshSignal={refreshSignal} />}
      {tab === "SPLIT" && (
        <SplitTransactionForm
          initialTransaction={splitTransaction}
          onSaved={handleSaved}
          onCancel={splitTransaction ? cancelMode : undefined}
        />
      )}
    </div>
  );
}
